import { render } from "./CancelReturn.vue?vue&type=template&id=461dd581&ts=true"
import script from "./CancelReturn.vue?vue&type=script&lang=ts"
export * from "./CancelReturn.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__